import { defineMessages, useIntl } from 'react-intl';
import { useMemo } from 'react';

// TODO: This is temporary, clean up this code after aid-static-assets is migrated
//       as part of https://hello.jira.atlassian.cloud/browse/KIRBY-7532
export const useTranslateFormErrorIfAvailable = (formError?: string) => {
  const { formatMessage } = useIntl();
  const message = useMemo(
    () => Object.values(formValidationMessages).find(({ id }) => id === formError),
    [formError]
  );
  if (message) {
    return formatMessage(message);
  } else {
    return formError;
  }
};

const formValidationMessages = defineMessages({
  unknownError: {
    id: 'com.atlassian.profile.unknownError',
    defaultMessage: 'An unknown error occurred',
  },
  errorRequiredField: {
    id: 'error.required',
    defaultMessage: 'This field is required',
  },
  loginFormNoPassword: {
    id: 'login.form.no.password',
    defaultMessage: 'Enter your password',
  },
  loginFormPasswordTooLong: {
    id: 'login.form.password.too.long',
    defaultMessage: 'Password length capped at 100 characters',
  },
  loginFormPasswordTooShort: {
    id: 'login.form.password.too.short',
    defaultMessage: 'The password is too short.',
  },
  resetPasswordGenericError: {
    id: 'resetPassword.error',
    defaultMessage: 'An error occurred while attempting to reset your password.',
  },
  resetPasswordEmailFormatError: {
    id: 'requestPasswordReset.email.format.error',
    defaultMessage: 'Please enter a valid email address',
  },
  signupDisplayNameEmpty: {
    id: 'signup.display.name.empty',
    defaultMessage: 'Full name must not be empty',
  },
  signupDisplayNameTooLong: {
    id: 'signup.display.name.too.long',
    defaultMessage: 'Full name must not be greater than 255 characters',
  },
  signupEmailFormatError: {
    id: 'signup.email.format.error',
    defaultMessage: 'Email is required to be in correct format',
  },
  signupEmailReachedMaxAliases: {
    id: 'signup.email.reached.max.aliases',
    defaultMessage: 'Email aliases are rate limited',
  },
  signupEmailRestrictedDomain: {
    id: 'signup.email.restricted.domain.error',
    defaultMessage: 'The provided email address is not allowed, please use a different one',
  },
  signupEmailBansNotAllowed: {
    id: 'signup.email.bans.not.allowed',
    defaultMessage: 'The provided email address is not allowed, please use a different one',
  },
  signupGenericFailure: {
    id: 'signup.failure',
    defaultMessage: 'We are unable to sign you up. Please contact support.',
  },
  signupCaptchaResponseError: {
    id: 'signup.captcha.response.required.error',
    defaultMessage: "Are you sure you're not a robot?",
  },
});
